import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const $ = window.$;

function InventoryOverviewTable({ tableData, isTextingEnabled }) {
  const tableEl = useRef();

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      data: tableData,
      dom: '<fB>tlip',
      lengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, 'All'],
      ],
      fnRowCallback: function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        var index = iDisplayIndexFull + 1 + '.';
        $('td:eq(0)', nRow).html(index);
        return nRow;
      },
      columnDefs: [{ className: 'text-center', targets: '_all' }],
      buttons: [
        { extend: 'colvis', text: 'Select Columns', columns: ':gt(0)' },
        {
          extend: 'excelHtml5',
          text: 'Data Export',
          title: 'Data-Export',
          exportOptions: {
            columns: function (idx, data, node) {
              var isVisible = table.column(idx).visible();
              const hideFromExport = [0];
              var isNotForExport = $.inArray(idx, hideFromExport) !== -1;
              return isVisible && !isNotForExport ? true : false;
            },
          },
        },
      ],
      columns: columnBuilder(isTextingEnabled),
      responsive: true,
      destroy: true,
    });

    return () => {
      table.destroy();
    };
  }, [tableData, isTextingEnabled]);

  return (
    <div className='table-responsive' style={{ paddingBottom: '30px', paddingTop: '30px' }}>
      <table
        ref={tableEl}
        className='table table-hover table-striped vertical_centered table-bordered'
        style={{ width: '100%' }}
      ></table>
    </div>
  );
}

function columnBuilder(isTextingEnabled) {
  const columns = [];

  columns.push({
    data: null,
    render: () => '&nbsp;',
    searchable: false,
    orderable: false,
  });
  columns.push({ data: 'landing_domain', title: 'Domain' });
  columns.push({ data: 'year', title: 'Year' });
  columns.push({ data: 'make', title: 'Make' });
  columns.push({ data: 'model', title: 'Model' });
  columns.push({ data: 'trim_type', title: 'Trim' });
  columns.push({ data: 'vin', title: 'VIN' });

  if (isTextingEnabled) {
    columns.push({ data: 'texts', title: 'Texts', render: $.fn.dataTable.render.number(',') });
  }

  columns.push({ title: 'WebForms', data: 'leads', render: $.fn.dataTable.render.number(',') });
  columns.push({ title: 'Chats', data: 'chats', render: $.fn.dataTable.render.number(',') });
  columns.push({ title: 'Calls', data: 'calls', render: $.fn.dataTable.render.number(',') });
  columns.push({ data: 'sales', title: 'Sales', render: $.fn.dataTable.render.number(',') });
  columns.push({
    data: 'service',
    title: 'Service',
    render: $.fn.dataTable.render.number(','),
  });
  columns.push({ data: 'parts', title: 'Parts', render: $.fn.dataTable.render.number(',') });
  columns.push({
    data: 'appts',
    title: 'Sales Appts',
    render: $.fn.dataTable.render.number(','),
  });
  columns.push({
    data: 'noappts',
    title: 'No Appts',
    render: $.fn.dataTable.render.number(','),
  });

  return columns;
}

InventoryOverviewTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  isTextingEnabled: PropTypes.bool.isRequired,
};

export default InventoryOverviewTable;
